module.exports = __webpack_public_path__ + "img/englishExam1.01c94fc7.png";